/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Err_Date_InvalidInputs */

const vi_einvoice_err_date_invalid = /** @type {(inputs: Einvoice_Err_Date_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hóa đơn không hợp lệ`)
};

/**

* @param {Einvoice_Err_Date_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_date_invalid = /** @type {((inputs?: Einvoice_Err_Date_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Date_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_date_invalid(inputs)
});